// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--2R10m","logo":"logo--3xB-f","footer":"footer--1Dav7"};